import { getContentListServerSideProps } from '../../lib/content-list-retriever'
import { CollectionScreen } from 'app/features/collection/screen'

export const getServerSideProps = getContentListServerSideProps('Tag')

export default function CollectionPage() {
  return <CollectionScreen type={'Tag'} />
}
